module.exports = __webpack_public_path__ + "static/img/SCIDRL.515b7b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/SCIDRL.png
// module id = 7Xc0
// module chunks = 1